import { useEffect } from 'react';
import faviconSvg from '../../assets/favicon.svg';

const Favicon = () => {
  useEffect(() => {
    // Definir título padrão
    document.title = 'SG - Inviolável';
    
    // Remover favicon existente
    const existingFavicon = document.querySelector('link[rel="icon"]');
    if (existingFavicon) {
      existingFavicon.remove();
    }

    // Adicionar novo favicon
    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/svg+xml';
    link.href = faviconSvg;
    document.head.appendChild(link);

    // Cleanup
    return () => {
      const favicon = document.querySelector('link[rel="icon"]');
      if (favicon) {
        favicon.remove();
      }
    };
  }, []);

  return null; // Este componente não renderiza nada
};

export default Favicon;
